/* tslint:disable */
/* eslint-disable */
/**
 * Swagger
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @interface Epsilon
 */
export class Epsilon {
    /**
     *
     * @type {string}
     * @memberof Epsilon
     */
    _id: string;
    /**
     *
     * @type {string}
     * @memberof Epsilon
     */
    namespace: string;
    /**
     *
     * @type {string}
     * @memberof Epsilon
     */
    type: string;
    /**
     *
     * @type {string}
     * @memberof Epsilon
     */
    apiKey: string;
    /**
     *
     * @type {boolean}
     * @memberof Epsilon
     */
    sandbox: boolean;
    /**
     *
     * @type {boolean}
     * @memberof Epsilon
     */
    autoApprove: boolean;
}
